import { render } from "./VueIFrame.vue?vue&type=template&id=9a82236c&scoped=true&ts=true"
import script from "./VueIFrame.vue?vue&type=script&lang=ts"
export * from "./VueIFrame.vue?vue&type=script&lang=ts"

import "./VueIFrame.vue?vue&type=style&index=0&id=9a82236c&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a82236c"]])

export default __exports__